import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as globalAdd from '../../../connectionString';
@Injectable()
export class SaPaypalInvoiceService {

  constructor(private http: HttpClient) { }
  getInvoiceInfo(transactionId) {
    return this.http.get(globalAdd.Paneladdress + 'api/MailInvoiceInfo/getInvoiceInfo?=transactionId='+transactionId);
    return this.http.post(globalAdd.Paneladdress + 'api/SA/MailInvoiceInfo/getInvoiceInfo', { transactionId: transactionId });
  }

  getSingleIpsTransaction(id) {
    // return this.http.post(globalAdd.Paneladdress + 'api/SA/IpsTransaction/getSingleIpsTransaction', { id: id });
    return this.http.get(globalAdd.Paneladdress + 'api/SA/IpsTransaction/getSingleIpsTransaction?id='+ id);

  }

}
